import {useEffect} from "react";

export const WithTitle = (props: any) => {
    useEffect(() => {document.title = `${props.title} - Cloud NGFW`;}, [])
    return props.children;
};

export default WithTitle;
